import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'src/interface/IRootState';
import { getLogos } from 'src/redux/reducers/imagesReduser';
import style from '../styles/StartPage.module.css'
import { Link } from 'react-router-dom';

const StartPage: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLogos(['p2pLogo']));
  }, [dispatch])

  const selectedLogos = useSelector((state: RootState) => state.images);
  
  return (
    <div className={style.container}>
      <div className={style.content}>
        <img src={selectedLogos.p2pLogo} alt="Logo" className={style.logo} />

        <h1 className={style.text}>Добро пожаловать в торговлю Р2Р товарами</h1>
        <p className={style.text}>Для того что-бы начать торговать, пожалуйста зарегестрируйтесь или авторизируйтесь. Далее выберите товар на маркетплейсе и начните сделку.</p>

        <div className={style.buttons}>
          <Link className={style.button} to={'/register'}>Register</Link>
          <Link className={style.button} to={'/login'}>Login</Link>
        </div>
      </div>
    </div>
  )
}

export default StartPage